export const translations = {
  it: {
    brand: {
      tagline: "Manufacturing Finder & Production OS",
      short: "Trova il partner produttivo giusto, in pochi click.",
      version: "R4Pro · v0.3 · Production OS",
    },
    onboarding: {
      skip: "Salta",
      next: "Avanti",
      start: "Inizia",
      review: "Rivedi introduzione",
      s1: {
        title: "Trova il produttore giusto.",
        subtitle: "Pubblica una richiesta e ricevi proposte da aziende qualificate.\nNiente marketplace, niente annunci: solo collaborazioni industriali.",
        blueWords: "produttore|giusto.",
      },
      s2: {
        title: "Gestisci tutto in un unico posto.",
        subtitle: "Richieste, proposte, trattative, documenti e messaggi restano collegati alla stessa lavorazione.",
        blueWords: "tutto",
      },
      s3: {
        title: "Lavora. Non perdere tempo.",
        subtitle: "Un'interfaccia progettata per essere semplice, veloce e intuitiva.\nMeno clic, più produzione.",
        blueWords: "Lavora.",
      },
    },
    nav: {
      dashboard: "Home",
      newRequest: "Nuova Richiesta",
      requests: "Opportunità",
      availability: "Disponibilità",
      producers: "Persone e Officine",
      community: "Community",
      messages: "Messaggi",
      notifications: "Notifiche",
      myRequests: "Le mie richieste",
      myProposals: "Le mie proposte",
      profile: "Profilo",
      account: "Account",
      logout: "Esci",
      newBadge: "nuovi",
    },
    login: {
      kicker: "R4Pro · Manufacturing Finder",
      welcome: "Benvenuto su R4Pro",
      subtitle: "Trova il partner produttivo giusto in pochi click. Pubblica richieste, rispondi a chi cerca, costruisci reputazione.",
      email: "Email",
      password: "Password",
      signIn: "Entra",
      or: "oppure",
      noAccount: "Nuovo su R4Pro?",
      register: "Crea un account",
      remember: "Ricordami",
      forgot: "Password dimenticata?",
      trustTitle: "Un network aperto",
      trustA: "Chiunque può pubblicare",
      trustB: "Match in secondi",
      trustC: "Reputazione trasparente",
      trustD: "Standard tecnici",
      flowTitle: "Come funziona",
      flow1: "Pubblichi o rispondi",
      flow2: "R4Pro suggerisce il match",
      flow3: "Costruisci reputazione",
      status: "Sistema operativo",
    },
    register: {
      title: "Crea il tuo account",
      subtitle: "Pubblica richieste, rispondi ad altre e cresci nel network. Un solo account, molti usi.",
      role: "Come ti definisci?",
      roleHelp: "Puoi comunque pubblicare richieste e rispondere. Nessuna categoria è chiusa.",
      types: {
        person: { t: "Persona", d: "Individui, maker, studenti, freelance, professionisti" },
        organization: { t: "Organizzazione", d: "Aziende, officine, laboratori, startup, associazioni" },
      },
      name: "Nome completo",
      company: "Realtà / progetto (opzionale)",
      email: "Email",
      password: "Password",
      continue: "Continua",
      back: "Indietro",
      finish: "Crea account",
      have: "Hai già un account?",
      signIn: "Accedi",
      step: "Passo",
      of: "di",
    },
    finder: {
      kicker: "Manufacturing Finder",
      hero: "Trova il produttore giusto,",
      heroAccent: "in pochi click.",
      subtitle: "Pubblica una richiesta o rispondi a chi cerca. R4Pro ti aiuta a scoprire opportunità, confrontare candidati e costruire reputazione — senza logiche da marketplace.",
      startCta: "Nuova richiesta",
      searchPlaceholder: "Es. Telaio in fibra di carbonio, 25 pezzi, tolleranza 0.1mm...",
      quickMaterial: "Materiali frequenti",
      howItWorks: "Il flusso R4Pro",
      howItWorksSub: "Pubblica, rispondi, ricevi valutazioni. La Compatibilità è un aiuto, non un giudizio.",
      step: "Passo",
      steps: {
        describe: { t: "Descrivi", d: "Materiale, tolleranze, quantità, tempi" },
        match: { t: "Match", d: "Compatibilità calcolata su capacità reali" },
        compare: { t: "Confronta", d: "Vedi motivi del match e reputazione" },
        contact: { t: "Contatta", d: "Messaggio diretto al candidato" },
        confirm: { t: "Conferma", d: "Chiudi il progetto, costruisci reputazione" },
      },
      activeSearch: "Ricerca attiva",
      liveMatches: "candidati",
      liveMatchesDesc: "Aggiornati sulla tua ultima ricerca",
      networkPulse: "Attività della rete",
      producersOnline: "Utenti attivi",
      avgMatchTime: "Match medio",
      requestsToday: "Richieste 24h",
      recentQueries: "Ricerche recenti",
      viewFinder: "Vedi tutto",
      resumeSearch: "Riprendi ricerca",
      newestPartners: "Ultimi arrivati",
      myRequestsTitle: "Le mie richieste",
      myRequestsSub: "Le tue richieste più recenti e le proposte ricevute.",
      myRequestsEmpty: "Non hai ancora pubblicato richieste.",
      viewAll: "Vedi tutte",
      opportunitiesTitle: "Opportunità per te",
      opportunitiesSub: "Richieste pubblicate da altri che sembrano fatte per te",
      topRequestsMonth: "Top richieste del mese",
      topRequestsWeek: "Top richieste della settimana",
      topRequestsSub: "Le più attive: proposte ricevute, trattative aperte, novità",
      topRequestsEmpty: "Ancora nessuna richiesta attiva.",
      proposalsCountLabel: "proposte",
      people: "Persone registrate",
      organizations: "Organizzazioni",
      openRequestsCount: "Richieste attive",
      completedCollabs: "Collaborazioni completate",
      noDataYet: "Nessun dato disponibile",
      noRepliesYet: "Nessuna risposta alle tue richieste.",
      noOpenRequests: "Nessuna richiesta aperta al momento.",
      noProducersYet: "Ancora nessun profilo nella rete.",
      noConversationsYet: "Nessuna conversazione.",
      newRepliesTitle: "Nuove risposte",
      newRepliesSub: "Chi ha risposto alle tue richieste",
      updatesLabel: "aggiornamenti",
      new: "nuovo",
      newFem: "nuova",
      newPlural: "nuovi",
    },
    newRequest: {
      title: "Nuova Richiesta",
      subtitle: "Descrivi cosa devi produrre. Chiunque può pubblicare.",
      step1: "Cosa produrre",
      step2: "Dettagli tecnici",
      step3: "Condizioni",
      step4: "Rivedi e pubblica",
      what: "Cosa devi produrre?",
      whatSub: "Descrivi il progetto in modo chiaro",
      titleField: "Titolo della richiesta",
      titlePlaceholder: "Es. Telaio in fibra di carbonio per bici da corsa",
      description: "Descrizione",
      descPlaceholder: "Descrivi il pezzo, l'uso previsto e i vincoli...",
      category: "Categoria",
      quantity: "Quantità",
      technical: "Dettagli tecnici",
      technicalSub: "Più sei preciso, migliore sarà il match",
      material: "Materiale",
      requiredProcesses: "Processi richiesti",
      requiredProcessesSub: "Seleziona le lavorazioni necessarie per identificare partner adatti",
      tolerance: "Tolleranza",
      finish: "Finitura",
      files: "File tecnici (CAD, PDF)",
      dropFiles: "Trascina qui i file o clicca per selezionare",
      aiImprove: "Migliora con AI",
      aiThinking: "L'AI sta riscrivendo...",
      aiApplied: "Testo migliorato con AI",
      conditions: "Condizioni",
      conditionsSub: "Definisci budget, tempi e consegna",
      budget: "Budget indicativo",
      deadline: "Consegna entro",
      location: "Luogo di consegna",
      review: "Rivedi e pubblica",
      reviewSub: "Controlla i dettagli prima di pubblicare",
      publish: "Pubblica richiesta",
      next: "Avanti",
      previous: "Indietro",
      published: "Richiesta pubblicata",
    },
    requests: {
      title: "Opportunità",
      subtitle: "Richieste pubblicate dalla community: rispondi a quelle che ti interessano.",
      search: "Cerca per parola chiave, materiale, categoria...",
      filters: "Filtri",
      filtersReset: "Reimposta",
      filterUrgent: "Solo urgenti",
      filterNew: "Solo nuove",
      filterHasBudget: "Con budget",
      emptyTitle: "Nessuna richiesta aperta al momento.",
      emptyHint: "Pubblica una nuova richiesta dalla pagina Nuova Richiesta.",
      sortBy: "Ordina per",
      sortCompat: "Compatibilità",
      sortNewest: "Più recenti",
      sortDistance: "Distanza",
      sortBudget: "Budget",
      sortResponseTime: "Tempo di risposta",
      sortReputation: "Reputazione",
      compatibility: "Compatibilità",
      qty: "Qty",
      openRequest: "Apri richiesta",
      respond: "Rispondi",
      new: "Nuova",
      urgent: "Urgente",
      whyMatch: "Perché il match",
      compatibilityToggle: "Analizza compatibilità",
      compatibilityToggleHelp: "Uno strumento di supporto — non un giudizio sulle persone.",
    },
    producers: {
      title: "Persone & Officine",
      subtitle: "Chi c'è nel network. Chiunque può pubblicare e rispondere.",
      search: "Cerca per nome, competenza, materiale...",
      view: "Apri profilo",
      invite: "Invita",
      favorite: "Preferito",
      filters: "Filtri",
      clear: "Reset",
      skill: "Competenze",
      material: "Materiali",
      certification: "Certificazioni",
      location: "Località",
      minReputation: "Reputazione minima",
      availability: "Disponibilità",
      any: "Tutte",
      addCompare: "Confronta",
      removeCompare: "Rimuovi",
      openCompare: "Apri confronto",
      compareEmpty: "Aggiungi fino a 3 candidati",
      results: "risultati",
      emptyTitle: "Nessuna persona o officina nella rete al momento.",
      emptyHint: "Registrati o invita qualcuno per iniziare.",
    },
    producer: {
      about: "Positioning",
      availability: "Disponibilità",
      skills: "Competenze",
      materials: "Materiali",
      machines: "Attrezzatura",
      certifications: "Certificazioni",
      portfolio: "Portfolio",
      contact: "Contatta",
      invite: "Invita alla richiesta",
      favorite: "Preferito",
      external: "Link esterni",
      rate: "Tariffa indicativa",
      leadTime: "Lead time",
      matchScoreTitle: "Compatibilità — solo per questa richiesta",
      matchScoreSub: "Strumento opzionale: aiuta a confrontare, non giudica le persone.",
      trustIndicators: "Reputazione professionale",
      responseRate: "Tasso di risposta",
      responseTime: "Tempo di risposta",
      onTime: "Consegne puntuali",
      verified: "Profilo verificato",
      yearsActive: "Anni sul network",
      completed: "Progetti chiusi",
      profileCompleteness: "Completezza profilo",
      reputation: "Reputazione",
      reputationSub: "Costruita nel tempo: progetti, qualità delle risposte, affidabilità.",
      newHere: "Nuovo su R4Pro",
    },
    matchScore: {
      title: "Analisi di Compatibilità",
      offHelp: "Attiva per vedere la Compatibilità. Non serve per contattare — è solo un aiuto per confrontare.",
      onHelp: "Compatibilità attiva. Puoi disattivarla in qualsiasi momento.",
      skills: "Competenze richieste",
      materials: "Materiali disponibili",
      capacity: "Capacità produttiva",
      location: "Distanza geografica",
      certifications: "Requisiti tecnici",
      viewDetails: "Vedi motivi del match",
    },
    reputation: {
      label: "Reputazione",
      levels: {
        founding: "Fondatore",
        expert: "Esperto",
        established: "Affermato",
        rising: "In crescita",
        new: "Nuovo",
      },
      newMember: "Nuovo membro",
      noCompletedCollabs: "Nessuna collaborazione completata al momento. La reputazione verrà calcolata solo dopo collaborazioni reali.",
      builtOn: "Reputazione costruita su",
      factors: {
        completed: "Progetti completati",
        response: "Qualità delle risposte",
        reliability: "Affidabilità",
        completeness: "Completezza profilo",
      },
    },
    availability: {
      title: "La tua disponibilità",
      subtitle: "Comunica il tuo stato produttivo al network",
      available: "Disponibile",
      availableDesc: "Accetto nuove richieste immediatamente",
      limited: "Limitata",
      limitedDesc: "Capacità ridotta, valuto caso per caso",
      unavailable: "Non disponibile",
      unavailableDesc: "In pausa, riprendo dal...",
      until: "Fino al",
      note: "Nota (opzionale)",
      save: "Salva disponibilità",
      saved: "Disponibilità aggiornata",
    },
    community: {
      title: "Community",
      subtitle: "Solo contenuti tecnici. Zero rumore.",
      tabs: { questions: "Domande", tutorials: "Tutorial", experiences: "Esperienze", events: "Eventi" },
      ask: "Fai una domanda",
      answers: "risposte",
      views: "visualizzazioni",
      topAnswered: "Risposte più utili",
      topAnsweredSub: "Ordinate per reputazione di chi risponde — non da algoritmi opachi.",
      by: "risposto da",
    },
    messages: {
      title: "Messaggi",
      search: "Cerca conversazioni",
      empty: "Seleziona una conversazione",
      placeholder: "Scrivi un messaggio...",
      send: "Invia",
      online: "Online",
      openRequest: "Apri richiesta",
    },
    notifications: {
      title: "Notifiche",
      markAll: "Segna tutte come lette",
      empty: "Nessuna notifica",
      accept: "Accetta",
      decline: "Rifiuta",
      message: "Messaggio",
      openRequest: "Apri richiesta",
      accepted: "Proposta accettata",
      declined: "Proposta rifiutata",
    },
    profile: {
      title: "Profilo",
      edit: "Modifica",
      language: "Lingua",
      account: "Account",
      preferences: "Preferenze",
      security: "Sicurezza",
      logout: "Esci",
      appearance: "Aspetto · Theme Studio",
      appearanceSub: "Scegli come R4Pro appare a te. Le impostazioni sono locali al dispositivo.",
      themeLabel: "Tema",
      themes: {
        warm: "Warm Studio",
        terminal: "Engineering Terminal",
        industrial: "Industrial / Factory",
        technical: "Technical White",
        dark: "Dark Studio",
        light: "Light Studio",
      },
      themeDesc: {
        warm: "Consigliato — carta calda, contrasto sobrio",
        terminal: "Tecnico, operativo, da officina avanzata",
        industrial: "Ambiente industriale, solido, diretto, adatto alla produzione",
        technical: "Documentazione tecnica su fondo bianco, accento arancione R4Pro",
        dark: "Grafite scuro per sessioni serali",
        light: "Neutro freddo, alto contrasto",
      },
      blueprintLabel: "Intensità blueprint",
      blueprint: { off: "Off", light: "Leggera", medium: "Media" },
      densityLabel: "Densità interfaccia",
      density: { compact: "Compatta", standard: "Standard" },
      recommended: "Consigliato",
    },
    account: {
      title: "Account",
      subtitle: "Informazioni di accesso e sicurezza. Il profilo pubblico si gestisce separatamente.",
      credentialsTitle: "Accesso",
      emailLabel: "Email di accesso",
      emailHint: "Questa email è privata e viene usata solo per l'accesso e le comunicazioni di servizio. Non è visibile pubblicamente su R4Pro.",
      typeTitle: "Tipo di account",
      typeLabel: "Tipo",
      typePerson: "Persona",
      typeOrg: "Organizzazione",
      typeHint: "Il tipo di account è stato definito in fase di registrazione e non è modificabile.",
      manageTitle: "Gestione",
      editProfile: "Modifica profilo pubblico",
      editProfileHint: "Aggiorna le informazioni visibili agli altri utenti R4Pro.",
      security: "Sicurezza",
      securityHint: "Password, sessioni e opzioni di sicurezza.",
      signOut: "Esci",
      dangerTitle: "Area sensibile",
      deleteTitle: "Elimina account",
      deleteHint: "Rimuove definitivamente l'account e tutti i contenuti collegati.",
      deletePermanent: "L'eliminazione è permanente e irreversibile. Verranno rimossi profilo, richieste, proposte, messaggi, notifiche e cronologia associati al tuo account.",
      deleteConfirmLabel: "Per confermare, digita ELIMINA in maiuscolo",
      deleteConfirmWord: "ELIMINA",
      deleteCancel: "Annulla",
      deleteConfirmBtn: "Elimina definitivamente",
      deleteNotAvailable: "L'eliminazione automatica non è ancora attivabile. Contatta support@r4pro.it per procedere in sicurezza.",
    },
    security: {
      title: "Sicurezza",
      subtitle: "Gestisci la password e le impostazioni di accesso al tuo account R4Pro.",
      identityTitle: "Identità autenticata",
      identityEmail: "Email di accesso",
      changePasswordTitle: "Cambia password",
      currentPassword: "Password attuale",
      newPassword: "Nuova password",
      confirmPassword: "Conferma nuova password",
      passwordHint: "Minimo 8 caratteri. Usa una password unica e difficile da indovinare.",
      updatePassword: "Aggiorna password",
      updating: "Aggiornamento in corso…",
      passwordUpdated: "Password aggiornata correttamente.",
      passwordUpdateFailed: "Impossibile aggiornare la password.",
      validation: {
        required: "Compila tutti i campi.",
        tooShort: "La nuova password deve avere almeno 8 caratteri.",
        mismatch: "Le due nuove password non coincidono.",
        sameAsCurrent: "La nuova password deve essere diversa da quella attuale.",
        wrongCurrent: "La password attuale non è corretta.",
        noEmail: "Nessuna email associata alla sessione.",
      },
      recoveryTitle: "Recupero password",
      recoveryHint: "Se preferisci, possiamo inviarti un'email con un link di recupero al tuo indirizzo attuale.",
      sendResetEmail: "Invia link di recupero",
      resetSent: "Ti abbiamo inviato il link di recupero. Controlla la posta.",
      sessionsTitle: "Sessioni",
      sessionsHint: "Per uscire dalla sessione corrente su questo dispositivo.",
      signOut: "Esci",
    },
    common: {
      km: "km",
      eur: "€",
      day: "g",
      days: "gg",
      open: "Apri",
      close: "Chiudi",
      cancel: "Annulla",
      save: "Salva",
      back: "Indietro",
      by: "di",
      loading: "Caricamento...",
      exportCsv: "Esporta CSV",
      show: "Mostra",
      hide: "Nascondi",
    },
    capabilities: {
      title: "Capacità produttive",
      subtitle: "Dichiara ciò che sei realmente in grado di fare. R4Pro userà queste informazioni per suggerirti le opportunità più adatte.",
      processes: "Processi / lavorazioni",
      materials: "Materiali gestibili",
      equipment: "Attrezzatura reale",
      equipmentName: "Nome attrezzatura",
      equipmentProcess: "Lavorazione associata",
      equipmentCapacity: "Capacità / disponibilità (opz.)",
      addEquipment: "Aggiungi manualmente",
      saved: "Capacità aggiornate",
      emptyHelp: "Nessuna capacità dichiarata. Compila almeno un processo o un materiale per iniziare a ricevere opportunità pertinenti.",
    },
    visibility: {
      title: "Visibilità del profilo",
      subtitle: "R4Pro è una directory di capacità produttive, non un elenco pubblico di persone. Scegli quanto del tuo profilo mostrare agli altri utenti.",
      open: "Profilo aperto",
      openHelp: "Gli utenti R4Pro registrati possono vedere il tuo profilo professionale completo.",
      private: "Profilo privato",
      privateHelp: "Rimani ricercabile per competenze, processi, materiali, attrezzatura, zona geografica e disponibilità. I dettagli personali e le informazioni complete restano nascoste finché non autorizzi l'accesso.",
      saved: "Visibilità aggiornata",
      badge: "Profilo privato",
      previewTitle: "Anteprima capacità",
      previewSub: "Questo profilo è privato. Puoi vedere le capacità professionali ma non i dettagli personali.",
      requestAccess: "Richiedi accesso al profilo",
      requestSent: "Richiesta inviata",
      requestPending: "Richiesta in attesa",
      requestApproved: "Accesso approvato",
      requestDenied: "Richiesta rifiutata",
      lockedTitle: "Contenuto riservato",
      lockedBody: "I dettagli completi di questo profilo sono visibili solo dopo l'approvazione del titolare.",
    },
    myRequests: {
      title: "Le mie richieste",
      subtitle: "Gestisci le richieste che hai pubblicato",
      active: "Attive",
      closed: "Chiuse",
      completed: "Completate",
      archived: "Archiviate",
      proposals: "Proposte",
      newLabel: "nuove",
      emptyTitle: "Non hai ancora pubblicato richieste",
      emptyHelp: "Crea la tua prima richiesta per iniziare a ricevere proposte.",
      withdraw: "Ritira richiesta",
      withdrawConfirm: "Confermi il ritiro? La richiesta sparirà dalle Opportunità pubbliche e si sposterà tra le archiviate. Le proposte già ricevute restano visibili.",
      withdrawn: "Richiesta ritirata",
      reopen: "Riapri",
    },
    myProposals: {
      title: "Le mie proposte",
      subtitle: "Segui lo stato delle proposte inviate",
      openRequest: "Vedi richiesta",
      chat: "Chat",
      emptyTitle: "Non hai ancora inviato proposte",
      emptyHelp: "Esplora le opportunità e invia la tua prima proposta.",
      exploreCta: "Vedi opportunità",
      status: {
        sent: "Inviata",
        pending: "Inviata",
        viewed: "Visualizzata",
        negotiating: "In trattativa",
        accepted: "Accettata",
        declined: "Rifiutata",
        withdrawn: "Ritirata",
        completed: "Completata",
      },
    },
    proposalDetail: {
      notFound: "Proposta non trovata.",
      accept: "Accetta proposta",
      decline: "Rifiuta",
      chat: "Apri chat",
      edit: "Modifica proposta",
      submitted: "Inviata",
      acceptedToast: "Proposta accettata. Iniziamo!",
      declinedToast: "Proposta rifiutata.",
      editKicker: "R4Pro · Modifica proposta",
      editTitle: "Aggiorna la tua proposta",
      editSubtitle: "Il cliente rivedrà i nuovi termini.",
      editing: "Modifica",
      saveChanges: "Salva modifiche",
      updated: "Proposta aggiornata",
      finalizedTitle: "Questa proposta è chiusa",
      finalizedHint: "Non è più modificabile — è stata accettata o rifiutata.",
      openProposal: "Apri proposta",
    },
    requestDetail: {
      compatibility: "Compatibilità stimata",
      compatibilityHelp: "Basata su un'euristica preliminare (skills, materiali, capacità, distanza, certificazioni). Il motore reale arriverà nella prossima iterazione.",
      replyCta: "Invia una proposta",
      replyHelp: "Aprirai il form per rispondere a questa richiesta.",
      proposals: "Proposte ricevute",
      noProposals: "Nessuna proposta ricevuta ancora.",
      accept: "Accetta",
      decline: "Rifiuta",
      chat: "Chat",
      openProposal: "Apri proposta",
      accepted: "Proposta accettata",
      declined: "Proposta rifiutata",
      notFound: "Richiesta non trovata o non più disponibile.",
      copied: "ID richiesta copiato",
      download: "Scarica",
      markCompleted: "Completa",
      archive: "Archivia",
      reopen: "Riapri",
      markedCompleted: "Richiesta segnata come completata",
      archived: "Richiesta archiviata",
      reopened: "Richiesta riaperta",
      notOpenTitle: "Questa richiesta non è più aperta",
      notOpenHint: "Non è possibile inviare nuove proposte quando la richiesta è in bozza, chiusa, completata o archiviata.",
    },
    proposal: {
      kicker: "R4Pro · Nuova proposta",
      title: "Rispondi a questa richiesta",
      subtitle: "Descrivi cosa proponi. Il cliente riceverà la proposta e potrà rispondere in chat.",
      messageLabel: "Messaggio",
      messagePlaceholder: "Presenta la tua proposta: approccio, esperienza, valore aggiunto...",
      priceLabel: "Prezzo stimato (opzionale)",
      daysLabel: "Consegna stimata in giorni (opzionale)",
      notesLabel: "Note aggiuntive (opzionali)",
      notesPlaceholder: "Condizioni, pagamento, garanzie...",
      filesLabel: "Allegati (opzionali)",
      submit: "Invia proposta",
      sent: "Proposta inviata",
      price: "Prezzo",
      days: "Giorni",
      errMessage: "Scrivi un messaggio per il cliente.",
      errMessageShort: "Il messaggio è troppo breve (almeno 20 caratteri).",
      errPrice: "Prezzo non valido.",
      errDays: "Numero di giorni non valido.",
      ownRequestError: "Non puoi rispondere alla tua stessa richiesta.",
      ownRequestBlockTitle: "Questa è la tua richiesta",
      ownRequestBlockHelp: "Le proposte ricevute compariranno nel dettaglio della richiesta.",
      requestNotOpen: "Questa richiesta non è più aperta.",
      requestNotOpenTitle: "Questa richiesta non è più aperta",
      requestNotOpenHint: "Non è possibile inviare una proposta quando la richiesta è in bozza, chiusa, completata o archiviata.",
    },
  },
  en: {
    brand: {
      tagline: "Manufacturing Finder & Production OS",
      short: "Find the right production partner, in a few clicks.",
      version: "R4Pro · v0.3 · Production OS",
    },
    onboarding: {
      skip: "Skip",
      next: "Next",
      start: "Get started",
      review: "Review introduction",
      s1: {
        title: "Find the right producer.",
        subtitle: "Publish a request and receive proposals from qualified companies.\nNo marketplace, no ads — only industrial collaboration.",
        blueWords: "producer.",
      },
      s2: {
        title: "Manage everything in one place.",
        subtitle: "Requests, proposals, negotiations, documents and messages stay linked to the same job.",
        blueWords: "everything",
      },
      s3: {
        title: "Work. Don't waste time.",
        subtitle: "An interface designed to be simple, fast and intuitive.\nFewer clicks, more production.",
        blueWords: "Work.",
      },
    },
    nav: {
      dashboard: "Home",
      newRequest: "New Request",
      requests: "Opportunities",
      availability: "Availability",
      producers: "People & Workshops",
      community: "Community",
      messages: "Messages",
      notifications: "Notifications",
      myRequests: "My Requests",
      myProposals: "My Proposals",
      profile: "Profile",
      account: "Account",
      logout: "Sign out",
      newBadge: "new",
    },
    login: {
      kicker: "R4Pro · Manufacturing Finder",
      welcome: "Welcome to R4Pro",
      subtitle: "Find the right production partner in a few clicks. Publish requests, respond to others, grow your reputation.",
      email: "Email",
      password: "Password",
      signIn: "Enter",
      or: "or",
      noAccount: "New to R4Pro?",
      register: "Create an account",
      remember: "Remember me",
      forgot: "Forgot password?",
      trustTitle: "An open network",
      trustA: "Anyone can publish",
      trustB: "Match in seconds",
      trustC: "Transparent reputation",
      trustD: "Technical standards",
      flowTitle: "How it works",
      flow1: "Publish or respond",
      flow2: "R4Pro suggests matches",
      flow3: "Build your reputation",
      status: "System operational",
    },
    register: {
      title: "Create your account",
      subtitle: "Publish requests, respond to others, grow in the network. One account, many uses.",
      role: "How do you describe yourself?",
      roleHelp: "You can publish and respond regardless of your choice. No category is closed.",
      types: {
        person: { t: "Person", d: "Individuals, makers, students, freelancers, professionals" },
        organization: { t: "Organization", d: "Companies, workshops, labs, startups, associations" },
      },
      name: "Full name",
      company: "Entity / project (optional)",
      email: "Email",
      password: "Password",
      continue: "Continue",
      back: "Back",
      finish: "Create account",
      have: "Already have an account?",
      signIn: "Sign in",
      step: "Step",
      of: "of",
    },
    finder: {
      kicker: "Manufacturing Finder",
      hero: "Find the right producer,",
      heroAccent: "in a few clicks.",
      subtitle: "Publish a request or respond to one. R4Pro helps you discover opportunities, compare candidates and build reputation — without marketplace pressure.",
      startCta: "New request",
      searchPlaceholder: "e.g. Carbon fiber frame, 25 pcs, ±0.1mm tolerance...",
      quickMaterial: "Frequent materials",
      howItWorks: "The R4Pro flow",
      howItWorksSub: "Publish, respond, get feedback. Compatibility is a helper — never a verdict.",
      step: "Step",
      steps: {
        describe: { t: "Describe", d: "Material, tolerances, quantity, timing" },
        match: { t: "Match", d: "Compatibility from real capabilities" },
        compare: { t: "Compare", d: "See match reasons and reputation" },
        contact: { t: "Contact", d: "Direct message to a candidate" },
        confirm: { t: "Confirm", d: "Close the project, build reputation" },
      },
      activeSearch: "Active search",
      liveMatches: "candidates",
      liveMatchesDesc: "Live on your latest search",
      networkPulse: "Network activity",
      producersOnline: "Active users",
      avgMatchTime: "Avg. match time",
      requestsToday: "Requests · 24h",
      recentQueries: "Recent searches",
      viewFinder: "View all",
      resumeSearch: "Resume search",
      newestPartners: "New in the network",
      myRequestsTitle: "My requests",
      myRequestsSub: "Your most recent requests and the proposals you have received.",
      myRequestsEmpty: "You haven't published any requests yet.",
      viewAll: "View all",
      opportunitiesTitle: "Opportunities for you",
      opportunitiesSub: "Requests published by others that seem tailored to you",
      topRequestsMonth: "Top requests this month",
      topRequestsWeek: "Top requests this week",
      topRequestsSub: "Most active right now: proposals received, negotiations open, latest activity",
      topRequestsEmpty: "No active requests yet.",
      proposalsCountLabel: "proposals",
      people: "Registered people",
      organizations: "Organizations",
      openRequestsCount: "Active requests",
      completedCollabs: "Completed collaborations",
      noDataYet: "No data available",
      noRepliesYet: "No replies to your requests yet.",
      noOpenRequests: "No open requests right now.",
      noProducersYet: "No profiles in the network yet.",
      noConversationsYet: "No conversations yet.",
      newRepliesTitle: "New replies",
      newRepliesSub: "People who responded to your requests",
      updatesLabel: "updates",
      new: "new",
      newFem: "new",
      newPlural: "new",
    },
    newRequest: {
      title: "New Request",
      subtitle: "Describe what you need to produce. Anyone can publish.",
      step1: "What to make",
      step2: "Technical details",
      step3: "Conditions",
      step4: "Review & publish",
      what: "What do you need to manufacture?",
      whatSub: "Describe the project clearly",
      titleField: "Request title",
      titlePlaceholder: "e.g. Carbon fiber road bike frame",
      description: "Description",
      descPlaceholder: "Describe the part, intended use and constraints...",
      category: "Category",
      quantity: "Quantity",
      technical: "Technical details",
      technicalSub: "The more precise, the better the match",
      material: "Material",
      requiredProcesses: "Required processes",
      requiredProcessesSub: "Pick the processes needed — matching uses this to find suitable partners",
      tolerance: "Tolerance",
      finish: "Finish",
      files: "Technical files (CAD, PDF)",
      dropFiles: "Drop files or click to select",
      aiImprove: "Improve with AI",
      aiThinking: "AI is rewriting...",
      aiApplied: "Text improved with AI",
      conditions: "Conditions",
      conditionsSub: "Set budget, timing and delivery",
      budget: "Indicative budget",
      deadline: "Deliver by",
      location: "Delivery location",
      review: "Review & publish",
      reviewSub: "Check details before publishing",
      publish: "Publish request",
      next: "Next",
      previous: "Back",
      published: "Request published",
    },
    requests: {
      title: "Opportunities",
      subtitle: "Requests published by the community — respond to those that interest you.",
      search: "Search by keyword, material, category...",
      filters: "Filters",
      filtersReset: "Reset",
      filterUrgent: "Urgent only",
      filterNew: "New only",
      filterHasBudget: "With budget",
      emptyTitle: "No open requests right now.",
      emptyHint: "Publish a new request from the New Request page.",
      sortBy: "Sort by",
      sortCompat: "Compatibility",
      sortNewest: "Newest",
      sortDistance: "Distance",
      sortBudget: "Budget",
      sortResponseTime: "Response time",
      sortReputation: "Reputation",
      compatibility: "Compatibility",
      qty: "Qty",
      openRequest: "Open request",
      respond: "Respond",
      new: "New",
      urgent: "Urgent",
      whyMatch: "Why this match",
      compatibilityToggle: "Analyze compatibility",
      compatibilityToggleHelp: "A support tool — never a verdict on people.",
    },
    producers: {
      title: "People & Workshops",
      subtitle: "Who's in the network. Everyone can publish and respond.",
      search: "Search name, skill, material...",
      view: "Open profile",
      invite: "Invite",
      favorite: "Favorite",
      filters: "Filters",
      clear: "Reset",
      skill: "Skills",
      material: "Materials",
      certification: "Certifications",
      location: "Location",
      minReputation: "Min. reputation",
      availability: "Availability",
      any: "Any",
      addCompare: "Compare",
      removeCompare: "Remove",
      openCompare: "Open comparison",
      compareEmpty: "Add up to 3 candidates",
      results: "results",
      emptyTitle: "No people or workshops in the network yet.",
      emptyHint: "Register or invite someone to get started.",
    },
    producer: {
      about: "Positioning",
      availability: "Availability",
      skills: "Skills",
      materials: "Materials",
      machines: "Equipment",
      certifications: "Certifications",
      portfolio: "Portfolio",
      contact: "Contact",
      invite: "Invite to request",
      favorite: "Favorite",
      external: "External links",
      rate: "Indicative rate",
      leadTime: "Lead time",
      matchScoreTitle: "Compatibility — for this request only",
      matchScoreSub: "Optional tool: helps compare, never judges people.",
      trustIndicators: "Professional reputation",
      responseRate: "Response rate",
      responseTime: "Response time",
      onTime: "On-time delivery",
      verified: "Verified profile",
      yearsActive: "Years on network",
      completed: "Projects closed",
      profileCompleteness: "Profile completeness",
      reputation: "Reputation",
      reputationSub: "Built over time: projects, response quality, reliability.",
      newHere: "New on R4Pro",
    },
    matchScore: {
      title: "Compatibility analysis",
      offHelp: "Enable to see the Compatibility score. Not needed to make contact — just a helper for comparison.",
      onHelp: "Compatibility enabled. You can turn it off at any time.",
      skills: "Required skills",
      materials: "Materials available",
      capacity: "Production capacity",
      location: "Geographic distance",
      certifications: "Technical requirements",
      viewDetails: "See match reasons",
    },
    reputation: {
      label: "Reputation",
      levels: {
        founding: "Founding",
        expert: "Expert",
        established: "Established",
        rising: "Rising",
        new: "New",
      },
      newMember: "New member",
      noCompletedCollabs: "No completed collaborations yet. Trust will be calculated only from real completed collaborations.",
      builtOn: "Reputation built from",
      factors: {
        completed: "Completed projects",
        response: "Response quality",
        reliability: "Reliability",
        completeness: "Profile completeness",
      },
    },
    availability: {
      title: "Your availability",
      subtitle: "Tell the network your production status",
      available: "Available",
      availableDesc: "Accepting new requests immediately",
      limited: "Limited",
      limitedDesc: "Reduced capacity, case by case",
      unavailable: "Unavailable",
      unavailableDesc: "On pause, back on...",
      until: "Until",
      note: "Note (optional)",
      save: "Save availability",
      saved: "Availability updated",
    },
    community: {
      title: "Community",
      subtitle: "Technical content only. Zero noise.",
      tabs: { questions: "Questions", tutorials: "Tutorials", experiences: "Experiences", events: "Events" },
      ask: "Ask a question",
      answers: "answers",
      views: "views",
      topAnswered: "Most useful answers",
      topAnsweredSub: "Sorted by the responder's reputation — not by opaque algorithms.",
      by: "answered by",
    },
    messages: {
      title: "Messages",
      search: "Search conversations",
      empty: "Select a conversation",
      placeholder: "Write a message...",
      send: "Send",
      online: "Online",
      openRequest: "Open request",
    },
    notifications: {
      title: "Notifications",
      markAll: "Mark all as read",
      empty: "No notifications",
      accept: "Accept",
      decline: "Decline",
      message: "Message",
      openRequest: "Open request",
      accepted: "Proposal accepted",
      declined: "Proposal declined",
    },
    profile: {
      title: "Profile",
      edit: "Edit",
      language: "Language",
      account: "Account",
      preferences: "Preferences",
      security: "Security",
      logout: "Sign out",
      appearance: "Appearance · Theme Studio",
      appearanceSub: "Choose how R4Pro looks to you. Settings are stored locally on this device.",
      themeLabel: "Theme",
      themes: {
        warm: "Warm Studio",
        terminal: "Engineering Terminal",
        industrial: "Industrial / Factory",
        technical: "Technical White",
        dark: "Dark Studio",
        light: "Light Studio",
      },
      themeDesc: {
        warm: "Recommended — warm paper, quiet contrast",
        terminal: "Technical, operational, control-system feel",
        industrial: "Industrial floor — robust, direct, production-ready",
        technical: "Technical documentation on white, R4Pro orange accent",
        dark: "Deep charcoal for evening sessions",
        light: "Cool neutral, high contrast",
      },
      blueprintLabel: "Blueprint intensity",
      blueprint: { off: "Off", light: "Light", medium: "Medium" },
      densityLabel: "Interface density",
      density: { compact: "Compact", standard: "Standard" },
      recommended: "Recommended",
    },
    account: {
      title: "Account",
      subtitle: "Login and security information. Public profile is managed separately.",
      credentialsTitle: "Sign-in",
      emailLabel: "Login email",
      emailHint: "This email is private and only used for login and service messages. It is not visible publicly on R4Pro.",
      typeTitle: "Account type",
      typeLabel: "Type",
      typePerson: "Individual",
      typeOrg: "Organization",
      typeHint: "The account type was chosen at registration and cannot be changed.",
      manageTitle: "Manage",
      editProfile: "Edit public profile",
      editProfileHint: "Update information visible to other R4Pro users.",
      security: "Security",
      securityHint: "Password, sessions and security options.",
      signOut: "Sign out",
      dangerTitle: "Danger zone",
      deleteTitle: "Delete account",
      deleteHint: "Permanently removes the account and all linked content.",
      deletePermanent: "Deletion is permanent and cannot be undone. Your profile, requests, proposals, messages, notifications and related history will be removed.",
      deleteConfirmLabel: "To confirm, type DELETE in uppercase",
      deleteConfirmWord: "DELETE",
      deleteCancel: "Cancel",
      deleteConfirmBtn: "Delete permanently",
      deleteNotAvailable: "Automated deletion is not enabled yet. Please contact support@r4pro.it to proceed safely.",
    },
    security: {
      title: "Security",
      subtitle: "Manage your password and how you sign in to R4Pro.",
      identityTitle: "Authenticated identity",
      identityEmail: "Sign-in email",
      changePasswordTitle: "Change password",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      passwordHint: "At least 8 characters. Use a unique, hard-to-guess password.",
      updatePassword: "Update password",
      updating: "Updating…",
      passwordUpdated: "Password updated successfully.",
      passwordUpdateFailed: "Could not update password.",
      validation: {
        required: "Please fill in all fields.",
        tooShort: "The new password must be at least 8 characters long.",
        mismatch: "The two new passwords do not match.",
        sameAsCurrent: "The new password must be different from the current one.",
        wrongCurrent: "Current password is incorrect.",
        noEmail: "No email associated with this session.",
      },
      recoveryTitle: "Password recovery",
      recoveryHint: "If you prefer, we can email you a recovery link at your current address.",
      sendResetEmail: "Send recovery email",
      resetSent: "Recovery link sent. Please check your inbox.",
      sessionsTitle: "Sessions",
      sessionsHint: "Sign out of the current session on this device.",
      signOut: "Sign out",
    },
    common: {
      km: "km",
      eur: "€",
      day: "d",
      days: "d",
      open: "Open",
      close: "Close",
      cancel: "Cancel",
      save: "Save",
      back: "Back",
      by: "by",
      loading: "Loading...",
      exportCsv: "Export CSV",
      show: "Show",
      hide: "Hide",
    },
    capabilities: {
      title: "Production capabilities",
      subtitle: "Declare what you can actually do. R4Pro uses this to surface the opportunities that fit you.",
      processes: "Processes / services",
      materials: "Materials you can handle",
      equipment: "Real equipment",
      equipmentName: "Equipment name",
      equipmentProcess: "Related process",
      equipmentCapacity: "Capacity / availability (opt.)",
      addEquipment: "Add manually",
      saved: "Capabilities updated",
      emptyHelp: "No capabilities declared yet. Add at least one process or material to start receiving relevant opportunities.",
    },
    visibility: {
      title: "Profile visibility",
      subtitle: "R4Pro is a directory of production capabilities, not a public list of people. Choose how much of your profile other users can see.",
      open: "Open profile",
      openHelp: "Registered R4Pro users can view your complete professional profile.",
      private: "Private profile",
      privateHelp: "You remain discoverable by skills, processes, materials, equipment, geographic area and availability. Personal details and the full profile stay hidden until you approve access.",
      saved: "Visibility updated",
      badge: "Private profile",
      previewTitle: "Capability preview",
      previewSub: "This profile is private. You can see the professional capabilities, but personal details are protected.",
      requestAccess: "Request profile access",
      requestSent: "Request sent",
      requestPending: "Request pending",
      requestApproved: "Access approved",
      requestDenied: "Request denied",
      lockedTitle: "Protected content",
      lockedBody: "The full profile details are only visible after the owner approves your request.",
    },
    myRequests: {
      title: "My Requests",
      subtitle: "Manage the requests you have published",
      active: "Active",
      closed: "Closed",
      completed: "Completed",
      archived: "Archived",
      proposals: "Proposals",
      newLabel: "new",
      emptyTitle: "You haven't published any request yet",
      emptyHelp: "Publish your first request to start receiving proposals.",
      withdraw: "Withdraw request",
      withdrawConfirm: "Withdraw this request? It will disappear from public Opportunities and move to Archived. Any proposals already received will remain visible.",
      withdrawn: "Request withdrawn",
      reopen: "Reopen",
    },
    myProposals: {
      title: "My Proposals",
      subtitle: "Track the status of the proposals you sent",
      openRequest: "View request",
      chat: "Chat",
      emptyTitle: "You haven't sent any proposal yet",
      emptyHelp: "Explore opportunities and submit your first proposal.",
      exploreCta: "Browse opportunities",
      status: {
        sent: "Sent",
        pending: "Sent",
        viewed: "Viewed",
        negotiating: "Negotiating",
        accepted: "Accepted",
        declined: "Declined",
        withdrawn: "Withdrawn",
        completed: "Completed",
      },
    },
    requestDetail: {
      compatibility: "Estimated Compatibility",
      compatibilityHelp: "Based on an early heuristic (skills, materials, capacity, distance, certifications). The real engine ships next iteration.",
      replyCta: "Submit a proposal",
      replyHelp: "You'll open the proposal form for this request.",
      proposals: "Proposals received",
      noProposals: "No proposals received yet.",
      accept: "Accept",
      decline: "Decline",
      chat: "Chat",
      openProposal: "Open proposal",
      accepted: "Proposal accepted",
      declined: "Proposal declined",
      notFound: "Request not found or no longer available.",
      copied: "Request ID copied",
      download: "Download",
      markCompleted: "Complete",
      archive: "Archive",
      reopen: "Reopen",
      markedCompleted: "Request marked as completed",
      archived: "Request archived",
      reopened: "Request reopened",
      notOpenTitle: "This request is no longer open",
      notOpenHint: "New proposals cannot be sent when the request is draft, closed, completed or archived.",
    },
    proposalDetail: {
      notFound: "Proposal not found.",
      accept: "Accept proposal",
      decline: "Decline",
      chat: "Open chat",
      edit: "Edit proposal",
      submitted: "Submitted",
      acceptedToast: "Proposal accepted. Let's start!",
      declinedToast: "Proposal declined.",
      editKicker: "R4Pro · Edit proposal",
      editTitle: "Update your proposal",
      editSubtitle: "The customer will see the new terms.",
      editing: "Editing",
      saveChanges: "Save changes",
      updated: "Proposal updated",
      finalizedTitle: "This proposal is finalized",
      finalizedHint: "It can no longer be edited — it has been accepted or declined.",
      openProposal: "Open proposal",
    },
    proposal: {
      kicker: "R4Pro · New proposal",
      title: "Reply to this request",
      subtitle: "Describe what you propose. The customer will receive it and can reply in chat.",
      messageLabel: "Message",
      messagePlaceholder: "Introduce your proposal: approach, experience, added value...",
      priceLabel: "Estimated price (optional)",
      daysLabel: "Estimated delivery in days (optional)",
      notesLabel: "Additional notes (optional)",
      notesPlaceholder: "Terms, payment, guarantees...",
      filesLabel: "Attachments (optional)",
      submit: "Submit proposal",
      sent: "Proposal sent",
      price: "Price",
      days: "Days",
      errMessage: "Write a message for the customer.",
      errMessageShort: "The message is too short (at least 20 characters).",
      errPrice: "Invalid price.",
      errDays: "Invalid number of days.",
      ownRequestError: "You cannot reply to your own request.",
      ownRequestBlockTitle: "This is your request",
      ownRequestBlockHelp: "Received proposals will appear in the request detail.",
      requestNotOpen: "This request is no longer open.",
      requestNotOpenTitle: "This request is no longer open",
      requestNotOpenHint: "You cannot submit a proposal when the request is draft, closed, completed or archived.",
    },
  },
};

export default translations;
